import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { SquadCastComponentsModule } from '../../components/squadcast.components.module';
import { TeamInvitePage } from './team-invite.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: TeamInvitePage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [TeamInvitePage],
})
export class TeamInviteModule {}
